<p class="mat-body-1">
  <ng-content></ng-content>
</p>
